import * as InsurancePermitFields from '@src/permitField/InsuranceInformationFields';
import { BooleanField } from '@src/permitField/PermitFields';

export class InsuranceCompanyField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceCompanyField.fieldName;
}

export class InsuranceEffectiveDateField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceEffectiveDateField.fieldName;
}

export class InsuranceExperienceDateField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceExperienceDateField.fieldName;
}

export class InsuranceCoverageAmountField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceCoverageAmountField.fieldName;
}

export class InsurancePolicyNumberField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsurancePolicyNumberField.fieldName;
}

export class InsuranceAgentField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceAgentField.fieldName;
}

export class InsurancePhoneNumberField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsurancePhoneNumberField.fieldName;
}

export class InsuranceAddressNumberField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceAddressNumberField.fieldName;
}

export class InsuranceIsOnFileWithStateField extends BooleanField {
  public static fieldName: string =
    InsurancePermitFields.InsuranceIsOnFileWithStateField.fieldName;
}
